import { render, staticRenderFns } from "./BookWaybills.vue?vue&type=template&id=278d6582&"
import script from "./BookWaybills.vue?vue&type=script&lang=js&"
export * from "./BookWaybills.vue?vue&type=script&lang=js&"
import style0 from "./BookWaybills.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports